import { isMobile } from "mobile-device-detect";
import React, { useState, useEffect, useRef } from "react";
import { useRouter } from "next/compat/router";
import SortByComp from "./SortByComp";
import StatsComp from "./StatsComp";
import PaginationComp from "./PaginationComp";
import FiltersComp from "./FiltersComp";
import ConfigureComp from "./ConfigureComp";
import BreadcrumbsComp from "./BreadcrumbsComp";
import { InstantSearch, ScrollTo, connectStateResults } from "react-instantsearch-dom";
import { searchClient,searchClientDefault } from "@/utils/algolia";
import { useSelector } from "react-redux";
import { buildLink, generateSlug, getSlug } from "@/helpers/slugHelper";
import { getSEOModelData } from "@/helpers/builderHelper";
import { reportError } from "@/helpers/errorHelper";
import SuperBrands from "../BuilderIO/SuperBrands";
import SeoDefinition from "../Header/SeoDefinition";
import { isNull } from "lodash";
import ErrorComponent from "pages/404";
import Error from "next/error";
import { builderClient } from "@/utils/builder";
import useNewOrReturningCustomer from "@/helpers/hooks/useNewOrReturningCustomer";
import { getUserCauseDetails } from "@/helpers/charityHelper";
import Head from "next/head";
import TextWithEllipse from "../common/TextWithEllipses";

const handlePageUpdate = (page = 1, router) => {
  let pages = {...router.query}
  let currentPage = pages.page || 1
  if(currentPage == page) {
    return
  }
  delete pages.pages
  if(router.query?.pages) {
    router.push({pathname: router.query.pages.join('/'), query: {...pages, page: page}})
  } else {
    router.push({query: {...router.query, page: page}})
  }
}

const StateResults = ({ error}) => {
  // const hasResults = searchResults && searchResults.nbHits !== 0;
  // const nbHits = searchResults && searchResults.nbHits;
  if(!isNull(error) && typeof error.transporterStackTrace != 'undefined'){
    reportError(JSON.stringify(error))
  }
  return (
    <></>
  );
};

const CustomStateResults = connectStateResults(StateResults);

// const SearchErrorCatcher = connectStateResults(
//   class SearchErrorCatcher extends Component {
//     error = null

//     UNSAFE_componentWillReceiveProps(nextProps) {
//       console.log('nextProps ===============')
//       if (this.error && !nextProps.error) {
//         this.error = null
//       }
//       if (!this.error && nextProps.error) {
//         // only throw on new errors
//         throw nextProps.error
//       }
//     }
//     render() {
//       return null
//     }
//   }
// )

const Productlist = (props) => {
  const generateBreadcrumb = async (filters) => {
    let cat = filters.category ? filters.category.split(",") : [];
    let subcat = filters.subcategory ? filters.subcategory.split(",") : [];
    let breadcrumbList = [];
    if (filters.type) {
      const link = await buildLink(filters.type);
      breadcrumbList.push({ link: link, text: filters.type });
    }
   
    if (filters.category) {
      if(cat.length >=2){

      }else{
        const link = await buildLink(filters.type, cat[0]);
        breadcrumbList.push({ link: link, text: cat[0] });
      }
     
    }
  
    if (filters.subcategory) {
      if(cat.length>=2 || cat.length == 0 || subcat.length >=2){

      }else{
        const link = await buildLink(filters.type, cat[0], subcat[0]);
        breadcrumbList.push({ link: link, text: subcat[0] });
      }
      
    }
    setBreadcrumbList(breadcrumbList)
  }
  const [type, setType] = useState(props.type);
  const [breadcrumbList, setBreadcrumbList] = useState([]);
  const [showMobileCondition, setShowMobileCondition] = useState(false);
  const algoliaClient = props.type === 'newest' || props.type === 'sale' || props.onlyWomen || props.collection ? searchClientDefault : searchClient;
  const filters = useSelector((state) => state.filters);
  const nbHitsCountData = useSelector((state) => state.nbHitsCount);

  const [seoData, setSeoData] = useState({});
  const router = useRouter()
  const skeletonRef = useRef()
  const quickLinkRef = useRef();
  useEffect(() => {
    if (isMobile) {
      setShowMobileCondition(true);
    }

    //Using split to strip the query params from the path to data from builder
    let SEOData = getSEOModelData(router.asPath.split("?")[0]);
    SEOData.then((data)=>{
      setSeoData(data)
    })
    
    
  }, []);
 
  useEffect(() => {
    generateBreadcrumb(filters);
  }, [filters]);

  const [buildertile1fetched, setBuildertile1fetched] = useState(false);
  const [buildertile2fetched, setBuildertile2fetched] = useState(false);
 
  const [builderContentJson1, setBuilderContentJson1] = useState(null);
  const [builderContentJson2, setBuilderContentJson2] = useState(null);
  const [plpscroll, plpsetScroll] = useState(false);

  // For targeting the content tile for new or returning customers
  const newOrReturningCustomer = useNewOrReturningCustomer();
  const userCauseDetails = getUserCauseDetails();
  const userCausePartner = typeof userCauseDetails != "undefined" && userCauseDetails && typeof userCauseDetails[0] != "undefined" && userCauseDetails[0]?.short_code;
  // Canonical URL checks if  its a homepage it will references the primary URL else it will append routerpath to the baseURL
  // split("?")= basically clean up the Url Parameter like "?query="
  const canonicalUrl = (`${process.env.NETLIFY_URL}` + (router.asPath === "/"? "": router.asPath)).split("?")[0];
  const isApp = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    builderClient.setUserAttributes({
      urlPath: router.asPath.split("?")[0],
      categories: [
        filters.type.toLowerCase(),
        filters.category.toLowerCase(),
        filters.subcategory.toLowerCase(),
      ],
      categoryMenu: [filters.type, filters.category, filters.subcategory],
      designers: router.query.brand?.toLowerCase(),
      designerMenu: router.query.brand?.toLowerCase(),
      customerType: newOrReturningCustomer,
      causePartner: userCausePartner,
      app: isApp
    });

    if (newOrReturningCustomer) {
      builderClient
        .get("content-tile-plp")
        .promise()
        .then((data) => { setBuilderContentJson1(data) })
        .catch((error)=>{ reportError(error) })
        .finally(() => { setBuildertile1fetched(true) });

      builderClient
        .get("content-tile-plp-2")
        .promise()
        .then((data) => { setBuilderContentJson2(data) })
        .catch((error)=>{ reportError(error) })
        .finally(() => { setBuildertile2fetched(true) });
    }
  }, [newOrReturningCustomer, userCausePartner]);
 
  let { pages = [] } = router.query;
  let params = pages.map((s) => decodeURI(s));
  const nostoPlacements = useSelector((state) => state.nosto.nostoPlacements);
  const [isCollection, setIsCollection] = useState(false);
  useEffect(() => {
    let plpSection = document.querySelector(".plp-section");
    window.addEventListener("scroll", () => {
      if(plpSection){
        if(plpSection.getBoundingClientRect().top.toFixed() <= 0) {
          plpsetScroll(true);
        }
         else {
          plpsetScroll(false);
         }
      }
    });
    if (router.asPath.includes("/collection")) {
      setIsCollection(true);
    }
    else {
      setIsCollection(false);
    }
  }, [setIsCollection]);
  // if(nbHitsCountData.nbHitsCount == 0){
  //   return <Error statusCode="404"></Error>
  // }else{
    return (
      <>
      <Head>
      {/* canonical links basically helps to  prevent parameters to appear on Google search results and also improves SEO */}
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <div className={plpscroll ? `v-none` : ``}>
          <SuperBrands />  
      </div>

      <SeoDefinition seoData={seoData} otherData={props} url={`${process.env.NETLIFY_URL}/${params.join("/")}`}/>
      <section className="plp-section">
        <BreadcrumbsComp breadcrumbList={breadcrumbList} />
        <div className="container">
          <div className="ais-InstantSearch">
            <div className="skeleton-active" ref={skeletonRef}>
              <img src="/plp-loading.svg" />
            </div>  
              {buildertile1fetched && buildertile2fetched && <InstantSearch
                indexName={process.env.SHOPIFY_PRIMARY_INDEX}
                searchClient={algoliaClient}
              >
                {!showMobileCondition && (
                  <ScrollTo>
                    <StatsComp seoData={seoData} skeletonRef={skeletonRef} brand_name={props.brand_name} nav_type={props.nav_type} nav_cat={props.nav_cat} nav_subcat={props.nav_subcat} />
                  </ScrollTo>
                )}
                {/* {
                !showMobileCondition && <FilterQuickLink />
              } */}
              {showMobileCondition && <StatsComp  seoData={seoData} skeletonRef={skeletonRef} brand_name={props.brand_name} nav_type={props.nav_type} nav_cat={props.nav_cat} nav_subcat={props.nav_subcat}/>}
              {seoData?.intro && <>
                 <div className="small-md x-small-sm x-small-xs seo-plp-data para-with-link mobile-ellipses d-none d-xs-block">
                  <TextWithEllipse text={seoData.intro}/>
                </div>
                <div className="small-md x-small-sm x-small-xs seo-plp-data para-with-link d-xs-none"  dangerouslySetInnerHTML={{ __html: seoData.intro }}>
                </div>
                </>
              }
              <div className="grid-md-12 filter-bar">
                <FiltersComp handlePageUpdate={handlePageUpdate} type={type} brand_name={props.brand_name} nav_type={props.nav_type} nav_cat={props.nav_cat} nav_subcat={props.nav_subcat} />
                <SortByComp type={type} />
              </div>
  
              <ConfigureComp
                type={type}
                collection={props.collection}
                onlyWomen={props.onlyWomen}
                buildertile1fetched={!!builderContentJson1}
                buildertile2fetched={!!builderContentJson2}
              />
  
              <PaginationComp
                handlePageUpdate={handlePageUpdate}
                builderContentJson1={builderContentJson1}
                builderContentJson2={builderContentJson2}
              />
              <CustomStateResults />
            </InstantSearch>}
          </div>
          {
            props.brand_name?(<div
              className="nosto_element pl-none pr-none"
              id="designer-plp-all"
              dangerouslySetInnerHTML={{
                __html: nostoPlacements["designer-plp-all"]
                  ? nostoPlacements["designer-plp-all"]
                  : ""
              }}
            ></div>):(
              props.collection || (props.type && (props.type =='sale'||props.type == 'newest')) ? <></> : (<div
              className="nosto_element pl-none pr-none"
              id="category-plp-all"
              dangerouslySetInnerHTML={{
                __html: nostoPlacements["category-plp-all"]
                  ? nostoPlacements["category-plp-all"]
                  : ""
              }}
            ></div>
            ))
            }
            {    
              (props.type && props.type == 'newest')&&
              <div
              className="nosto_element pl-none pr-none"
              id="new-arrivals-plp"
              dangerouslySetInnerHTML={{
                __html: nostoPlacements["new-arrivals-plp"]
                  ? nostoPlacements["new-arrivals-plp"]
                  : ""
              }}
            ></div>
            }
            {    
              isCollection &&
              <div
              className="nosto_element pl-none pr-none"
              id="collection-plp-all"
              dangerouslySetInnerHTML={{
                __html: nostoPlacements["collection-plp-all"]
                  ? nostoPlacements["collection-plp-all"]
                  : ""
              }}
            ></div>
            }
        </div>
      </section>
      </>
    );
  // }
  
};

export default Productlist;
